import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'addTime',
      type: 'dateTimePicker',
      label: '日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
